<script>
import IntegrationsBase from "@/components/tools/IntegrationsBase.vue";
import ActiveCampaign from "@/components/tools/modals/ActiveCampaign.vue";
import LeadLovers from "@/components/tools/modals/LeadLovers.vue";
import RDStation from "@/components/tools/modals/RDStation.vue";
export default {
  extends: IntegrationsBase,
  data() {
    return {
      name: "E-mail marketing",
      subtitle: "Integre suas contas ao ZeusPay"
    };
  },
  computed: {
    options() {
      return [
        {
          title: "Active Campaign",
          image: require("@/assets/images/integrations/active-campaign.svg"),
          description: "Integre sua conta da Active Campaign ao ZeusPay",
          modal: ActiveCampaign,
          name: "active-campaign"
        },
        {
          title: "LeadLovers",
          image: require("@/assets/images/integrations/leadlovers.svg"),
          description: "Integre sua conta da LeadLovers ao ZeusPay",
          modal: LeadLovers,
          name: "leadlovers"
        },
        {
          title: "RD Station Marketing",
          image: require("@/assets/images/integrations/rdstation.png"),
          description: "Integre sua conta da RD Station Marketing ao ZeusPay",
          modal: RDStation,
          name: "rd-station"
        }
      ];
    }
  }
};
</script>
